import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  // Wait for auth to load before deciding
  if (loading) {
    return <div className="text-center py-8">Loading...</div>;
  }

  // If no user after loading, redirect to login
  return user ? children : <Navigate to="/login" replace />;
}
